import React from "react"
import { Box, Container, Image, Text } from "theme-ui"
import { GatsbyImage } from "gatsby-plugin-image"
import ImageAndText from "../components/blocks/imageAndText"
const ImageTextCollection = ({ block }) => {
  const { kicker, blocks } = block

  return (
    <Container sx={{ pt: "0px!important" }}>
      <Text as="p" sx={{}} variant="kicker">
        {kicker}
      </Text>
      {blocks.map((block, index) => (
        <ImageAndText
          subtitle={block.subtitle}
          title={block.title}
          body={block.body}
          key={index}
          media={block.video}
          accordion={block.accordion}
        />
      ))}
    </Container>
  )
}

export default ImageTextCollection
